module.exports = __webpack_public_path__ + "static/img/CgoRDGRCUl2AbzxtAAEOdgtTceI190.c8fc45b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRDGRCUl2AbzxtAAEOdgtTceI190.jpg
// module id = 6JRu
// module chunks = 73